import React, { useEffect, useState } from "react";
import { Navbar, Dropdown } from "react-bootstrap";
import XdcIcon from "../assets/img/xdc-favicon/android-icon-36x36.png";
import { Link, useHistory, useLocation } from "react-router-dom";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function Header() {
  const options = [
    { label: "Mainnet Network", value: "mainnet" },
    { label: "Testnet Network", value: "testnet" },
  ];

  const [selected, setSelected] = useState(options[0]);
  const history = useHistory();
  const location = useLocation();
  const query = useQuery();
  const getNetwork = query.get("network");

  // Initialize selected based on URL params
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const networkParam = params.get("network");

    if (networkParam === "testnet") {
      setSelected(options[1]);
    } else {
      setSelected(options[0]); // default to mainnet
    }
  }, [location.search]); // Only depend on location.search

  // Handle network change
  const handleNetworkChange = (option) => {
    setSelected(option);

    // Only update URL if we're on the raw-tx page
    const params = new URLSearchParams(location.search);

    if (option.value === "mainnet") {
      params.delete("network"); // Remove param for mainnet (default)
    } else {
      params.set("network", option.value);
    }

    const newSearch = params.toString();
    const newPath = newSearch
      ? `${location.pathname}?${newSearch}`
      : location.pathname;

    history.replace(newPath); // Use replace instead of push to avoid history clutter
  };

  return (
    <Navbar className="custom-header" bg="light" expand="lg">
      <div className="container" style={{ gap: "10px" }}>
        <Link
          className="navbar-brand d-flex align-items-center"
          to={getNetwork ? `/raw-tx?network=${getNetwork}` : `/raw-tx`}
        >
          <img src={XdcIcon} alt="xdc" />
          XDC Broadcaster
        </Link>
        <Dropdown>
          <Dropdown.Toggle
            variant="none"
            className="btn btn-dark"
            id="dropdown-basic"
            style={{ fontSize: "16px" }}
          >
            {selected.label}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {options.map((option, idx) => (
              <Dropdown.Item
                style={{ fontSize: "14px" }}
                key={idx}
                onClick={() => handleNetworkChange(option)}
                active={option.value === selected.value}
              >
                {option.label}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </Navbar>
  );
}

export default Header;
